import { useState, useEffect } from "react";
import Box from "@mui/material/Box";

export default function WhatsAppButton() {
  const [ringColor, setRingColor] = useState("#ffffff");

  useEffect(() => {
    const visible = new Set();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) visible.add(e.target);
          else visible.delete(e.target);
        });

        const lightVisible = [...visible].some(
          (el) => el.dataset.ring === "light",
        );
        const darkVisible = [...visible].some(
          (el) => el.dataset.ring === "dark",
        );
        setRingColor(lightVisible && !darkVisible ? "#0d2340" : "#ffffff");
      },
      {
        rootMargin: "-80% 0px 0px -60%",
        threshold: 0,
      },
    );

    document
      .querySelectorAll("[data-ring]")
      .forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: 16, sm: 20, md: 24 },
        right: { xs: 16, sm: 20, md: 24 },
        zIndex: 9999,
        width: { xs: 64, sm: 72, md: 84 },
        height: { xs: 64, sm: 72, md: 84 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Rotating "Contact Us" ring */}
      <Box
        component="svg"
        viewBox="0 0 84 84"
        sx={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          "@keyframes spinRing": {
            from: { transform: "rotate(0deg)" },
            to: { transform: "rotate(360deg)" },
          },
          animation: "spinRing 10s linear infinite",
          transformOrigin: "center",
        }}
      >
        <defs>
          <path
            id="ringTextPath"
            d="M42,42 m-36,0 a36,36 0 1,1 72,0 a36,36 0 1,1 -72,0"
          />
        </defs>
        <text
          fontSize="6"
          fontFamily="inherit"
          fontWeight="600"
          letterSpacing="2.2"
          style={{ fill: ringColor, transition: "fill 0.4s ease" }}
        >
          <textPath href="#ringTextPath">
            {
              "CONTACT US  \u25CF  CONTACT US  \u25CF  CONTACT US  \u25CF  CONTACT US  \u25CF  "
            }
          </textPath>
        </text>
      </Box>

      {/* WhatsApp icon button */}
      <Box
        component="a"
        href="https://wa.me/201036689217"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          width: { xs: 44, sm: 50, md: 56 },
          height: { xs: 44, sm: 50, md: 56 },
          borderRadius: "50%",
          background: "#25D366",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 16px rgba(37,211,102,0.45)",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          "&:hover": {
            transform: "scale(1.1)",
            boxShadow: "0 8px 24px rgba(37,211,102,0.6)",
          },
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="100%"
          height="100%"
          style={{
            width: "55%",
            height: "55%",
            fill: "#fff",
          }}
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
      </Box>
    </Box>
  );
}
